var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuttingInActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6152 0.667175C26.5106 0.712914 26.3538 0.823994 26.2819 0.908936C26.1578 1.04615 22.4334 6.966 22.0283 7.66514C21.9499 7.80889 21.878 8.02452 21.878 8.14866C21.878 8.33162 20.5451 10.612 15.1741 19.629L8.47014 30.8806L8.26758 30.8545C7.36588 30.7369 1.81848 30.2991 1.4591 30.3187C0.707688 30.371 0.250304 30.6911 0.0542829 31.3119C-0.115602 31.8477 0.139225 33.2721 0.459394 33.5726C0.537802 33.6445 0.707688 33.7295 0.838369 33.7621C0.962516 33.7948 2.74631 33.8732 4.79147 33.932C8.90138 34.0496 9.26729 34.0366 9.91416 33.7164C10.6852 33.3374 10.7636 32.7886 10.1886 31.8934L9.9403 31.5079L16.5593 20.4131C22.4595 10.514 23.2044 9.29866 23.4266 9.16797C23.6357 9.03729 23.995 8.50803 25.805 5.59385C26.9811 3.71858 27.9743 2.10467 28.02 2.01972C28.1311 1.8041 28.0657 1.26178 27.9089 1.04615C27.6018 0.634506 27.0399 0.471157 26.6152 0.667175Z",
    fill: "#8D9091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuttingInActiveIcon);
export default __webpack_public_path__ + "static/media/puttingInActiveIcon.8860e210d84a32f91cc97f8a775267c8.svg";
export { ForwardRef as ReactComponent };